export default __webpack_public_path__ + "static/WWblacklodge-upward-scrolling-anim-838a14672b0fc74f711bb60425e80727.gif";